<template>
  <ShippingPromiseChristmas
    v-if="showChristmasUI"
    :choices
    :express-delivery-data="
      getDeliveryDates({ choices: props.choices, express: true })
    "
    :free-delivery-data="
      getDeliveryDates({ choices: props.choices, express: false })
    "
  />
  <div v-else class="whitespace-break-spaces">
    <div>
      {{ i18n(translations.shippingPromise, getDeliveryDates({ choices })) }}
    </div>

    <div v-if="choices.some((choice) => choice.price !== 0)">
      {{
        i18n(
          translations.shippingPromiseExpress,
          getDeliveryDates({ choices, express: true }),
        )
      }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import type { ShippingChoice } from '@backmarket/http-api/src/api-specs-checkout/cart/cart.types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { useDeliveryBeforeChristmas } from '~/scopes/product/composables/useDeliveryBeforeChristmas'
import { useDeliveryDateAdjustment } from '~/scopes/product/composables/useDeliveryDateAdjustement'

import translations from './ShippingPromise.translations'
import ShippingPromiseChristmas from './components/ShippingPromiseChristmas.vue'

const props = defineProps<{
  choices: ShippingChoice[]
}>()

const { FF_ENABLE_CHECKOUT_WITH_DELIVERY_BEFORE_CHRISTMAS } =
  useRuntimeConfig().public

const i18n = useI18n()
const deliveryDateAdjustment = useDeliveryDateAdjustment()

const { isChristmasTime } = useDeliveryBeforeChristmas()

const showChristmasUI = computed(
  () =>
    FF_ENABLE_CHECKOUT_WITH_DELIVERY_BEFORE_CHRISTMAS && isChristmasTime.value,
)

const getDeliveryDates = ({
  choices,
  express = false,
}: {
  choices: ShippingChoice[]
  express?: boolean
}) => {
  let earliest: Date | undefined
  let latest: Date | undefined
  let amount = ''

  choices
    .filter((choice) => (express ? choice.price !== 0 : choice.price === 0))
    .forEach((choice) => {
      if (choice.earliestArrivalDate) {
        const newDate = new Date(choice.earliestArrivalDate)
        earliest = earliest ?? newDate
        earliest = newDate < earliest ? newDate : earliest
      }

      if (choice.latestArrivalDate) {
        const newDate = new Date(choice.latestArrivalDate)
        latest = latest ?? newDate

        if (newDate >= latest) {
          latest = newDate
          amount = choice.priceWithCurrency
        }
      }
    })

  return {
    earliest: earliest
      ? i18n.date(deliveryDateAdjustment(earliest), {
          month: 'short',
          day: 'numeric',
        })
      : '',
    latest: latest ? i18n.date(latest, { month: 'short', day: 'numeric' }) : '',
    amount,
  }
}
</script>
